module.exports = false;



//////////////////
// WEBPACK FOOTER
// /var/www/beauty-shop.ru/~/core-js/modules/_library.js
// module id = 680
// module chunks = 32